import React from 'react';
import { Modal } from 'reactstrap';
import LeaderboardAwardHistoryTable from './LeaderboardAwardHistoryTable';

const LeaderboardAwardPopup = ({ participant, isOpen, setOpen, toggle, leaderboardId }) => {
  const name = participant
    ? `${participant.first_name ?? ''} ${participant.last_name ?? ''}`.trim()
    : null;

  return (
    <Modal className="award-history-modal" size="xl" isOpen={isOpen} toggle={() => setOpen(true)}>
      <div className="award-history-modal__inner">

        <div className="award-history-modal__header">
          <div className="award-history-modal__header-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="award-history-modal__header-text">
            <h3 className="award-history-modal__title">Award History</h3>
            {name && <p className="award-history-modal__subtitle">{name}</p>}
          </div>
          <button className="award-history-modal__close" onClick={toggle} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="award-history-modal__body">
          <LeaderboardAwardHistoryTable participant={participant} leaderboardId={leaderboardId} />
        </div>

      </div>
    </Modal>
  );
};

export default LeaderboardAwardPopup;
